import React from "react";
import { NakiNigunSearchResultGridCellTemplate } from "themes/application/naki-nigun/components";

function NakiNigunSearchResultGridCell(props) {
    return <NakiNigunSearchResultGridCellTemplate {...props} />;
}

export default NakiNigunSearchResultGridCell;
